import { alertConstants } from '../constants'

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        ...state,
        messageType: 'success',
        message: action.message
      };
    case alertConstants.ERROR:
      return {
        ...state,
        messageType: 'error',
        message: action.message
      };
    case alertConstants.CLEAR:
      return {...state, message: null};
    default:
      return state
  }
}